
export type jsonldData = Record<string, unknown>;

export type jsonldItem = Readonly<{
  id: string;
  dataSchema: jsonldData;
  dataQa?: string
}>;

export function Jsonld({ id, dataSchema, dataQa }: jsonldItem): JSX.Element {
  return (
    <script
      id={id}
      data-qa={dataQa}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(dataSchema) }}
    />
  );
}